import React from "react";
import { Navigate } from "react-router-dom";

function ProtectedRoute({ children, role }) {
  const userRole = localStorage.getItem("role");
  if (!userRole) {
    // Not logged in
    return <Navigate to="/login" replace />;
  }
  if (role && userRole !== role) {
    // Not correct role
    return <Navigate to="/login" replace />;
  }
  return children;
}

export default ProtectedRoute;
